
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Tests A/B en publicité digitale : pourquoi et comment les réussir",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez pourquoi les tests A/B sont essentiels pour améliorer vos campagnes publicitaires digitales et comment les mettre en place efficacement. Suivez nos conseils ! ",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Tests A/B en publicité digitale : pourquoi et comment les réussir",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez pourquoi les tests A/B sont essentiels pour améliorer vos campagnes publicitaires digitales et comment les mettre en place efficacement. Suivez nos conseils ! ",
        },
      ],
    };
  },
};
